// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__2_8ul","animation":"Spinner_animation__2s-93","white":"Spinner_white__2-crM","black":"Spinner_black__V-ybu"};